import { useEffect, useRef } from "react";


export function useOutsideClick<T extends HTMLElement>(ref: React.RefObject<T | null>, onClose: () => void){
	const onCloseRef = useRef(onClose);
	useEffect(() => { onCloseRef.current = onClose; }, [onClose]);

	useEffect(() => {
		function handleClick(event: MouseEvent) {
			if (ref.current && !ref.current.contains(event.target as Node)) {
				onCloseRef.current(); // 항상 최신 함수 실행
			}
		}
		document.addEventListener("mousedown", handleClick);
		return () => document.removeEventListener("mousedown", handleClick);
	}, [ref]);
}
